import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import AllocationFormLayout from './containers/Form';
import AllocationsGridLayout from './containers/Grid';

export default function AllocationLayout() {
  return <Router>
    <PrivateRoute exact
      path="/offer/allocations"
      component={AllocationsGridLayout}
    />
    <PrivateRoute
      path="/offer/allocations/:id/generator"
      component={AllocationsGridLayout}
    />
    <PrivateRoute
      path="/offer/allocations/:id/cost-updater"
      component={AllocationsGridLayout}
    />
    <PrivateRoute
      path={["/offer/allocations/add", "/offer/allocations/:id"]}
      component={AllocationFormLayout} />
  </Router>
}
